var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', [_c('tip'), _c('inbound-plan-add', {
    attrs: {
      "type": _vm.$enum.common.ModalTypeEnum.ADD
    }
  })], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };